import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import zhTranslations from './locales/zh.json';

// Get user's language preference from localStorage, browser, or default to English
const getUserLanguage = () => {
  // Check localStorage first
  const savedLanguage = localStorage.getItem('preferredLanguage');
  if (savedLanguage) {
    return savedLanguage;
  }

  // Check browser language
  const browserLang = navigator.language || navigator.userLanguage;

  // Map browser language codes to our supported languages
  if (browserLang.startsWith('es')) return 'es';
  if (browserLang.startsWith('zh')) return 'zh';

  // Default to English
  return 'en';
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      zh: { translation: zhTranslations },
    },
    lng: getUserLanguage(), // language to use
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // Set to false to avoid issues with SSR
    },
  });

// Save language preference whenever it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('preferredLanguage', lng);
  // Update HTML lang attribute for accessibility
  document.documentElement.lang = lng;
});

export default i18n;
